import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"


const Wrapper = styled.div`
  position: absolute;
  left: 15px;
  top: calc(50% - 3px);
  width: calc(100% - 30px);
  height: 6px;
  background-color: ${({color}) => color};
  pointer-events: none;
  user-select: none;
`

const Seek = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  background-color: ${({color}) => color};
  transition: width 0.25s ease;
`


const Bar = ({progressPercentage, color, activeColor, ...props}) => {
  const idNamespace = id("Bar", props)

  return (
    <Wrapper id={idNamespace} color={color}>
      <Seek color={activeColor} id={id("seek", idNamespace)} style={{width: `${progressPercentage}%`}} />
    </Wrapper>
  )
}

Bar.propTypes = {
  progressPercentage: PropTypes.number,
  color: PropTypes.string.isRequired,
  activeColor: PropTypes.string.isRequired
}
Bar.defaultProps = {
  progressPercentage: 0
}

export default Bar
